<div class="row">
    <div class="col-md-12 grid-margin stretch-card">
        <div class="card card-fit">
            <div class="card-header">
                <div class="row w-100">
                    <div class="col-12 d-flex justify-content-between align-items-start">
                        <h2 class="card-title">{{ title }}</h2>
                        <div class="d-flex gap-4 align-items-center">
                            <button type="button" class="btn btn-sm btn-outline-primary" rippleEffect
                                (click)="handleRequestFeedback()">
                                Enviar feedback
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <app-table-list-abstract (queryMethod)="query()" [menuActions]="menuActions" [searchable]="searchable"
                    [items]="list" [count]="count" [queryParams]="queryParams" [fields]="fieldParams" [columns]="fields"
                    [exclude]="exclude" [canEdit]="canEdit" [canDelete]="canDelete" [service]="service"
                    [customActions]="customActions" [emitQueryMethod]="emitQueryMethod" [isLoading]="isLoading">
                </app-table-list-abstract>

            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12 grid-margin stretch-card">
        <div class="card card-fit">
            <div class="card-header">
                <div class="row w-100">
                    <div class="col-12 d-flex justify-content-between align-items-start">
                        <h2 class="card-title">Solicitações recebidas</h2>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <app-table-list-abstract (queryMethod)="query()" [menuActions]="true" [searchable]="searchable"
                    [items]="list" [count]="count" [queryParams]="queryParams" [fields]="fieldParams"
                    [columns]="fieldsRequest" [exclude]="exclude" [canEdit]="canEdit" [canDelete]="canDelete"
                    [service]="service" [customActions]="customActionsRequest" [emitQueryMethod]="emitQueryMethod"
                    [isLoading]="isLoading">
                </app-table-list-abstract>

            </div>
        </div>
    </div>
</div>
<!-- 
<app-send-feedback-drawer
        *ngIf="drawerRequestState"
        [requestFeedback]="requestFeedback"
        (onCancel)="onCancel()"
>
</app-send-feedback-drawer>

<app-view-feedback
        *ngIf="drawerViewState"
        [feedbackView]="list[0]"
        (onCancel)="onCancel()"
></app-view-feedback> -->